export default __webpack_public_path__ + "static/media/project-not-added-to-profile.b6f59a29.svg";